<template>
  <fa-icon v-if="icon" class="mr-2" :icon="icon" v-bind="$attrs" size="sm" />
</template>

<script>
export default {
  props: ['icon'],
}
</script>
